import React, { useState } from "react";

const Contact = () => {
  const [copy, setCopy] = useState("");
  const mail = "vialleconstruction@gmail.com";
  const tel = "438-990-8198";
  const handleCopy = (texte) => {
    setCopy(texte);
    navigator.clipboard.writeText(texte);
    setTimeout(() => {
      setCopy("");
    }, 2000);
  };
  return (
    <div className="contact-container">
      <h4>Contactez-nous</h4>
      <div className="contacts">
        <div className="contact">
          <a href="mailto:vialleconstruction@gmail.com">{mail}</a>
          <button
            onClick={() => handleCopy(mail)}
            style={
              copy === mail
                ? { background: "#07d707", color: "white" }
                : { background: "black" }
            }
          >
            {copy === mail ? "Copié !" : "Copier"}
          </button>
        </div>
        <div className="contact">
          <a href="tel:+14389908198">{tel}</a>
          <button
            onClick={() => handleCopy(tel)}
            style={
              copy === tel
                ? { background: "#07d707", color: "white" }
                : { background: "black" }
            }
          >
            {copy === tel ? "Copié !" : "Copier"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
